import {
  DASH_FOR_PRICE_QUOTE_FIELDS,
  HOLIDAY_LIGHTING_ID,
  WINDOW_TINTING_ID,
} from "../feature/quotation/Constants/constants";
import { FormValues } from "../Interface/scheduler/form";
import { formatPrice } from "./utility";

export function generateHTMLEstimateNotes(
  estimationData,
  nonPricableEstimationData,
  formValues: FormValues
) {
  if (
    (!Array.isArray(estimationData) || estimationData.length === 0) &&
    (!nonPricableEstimationData || nonPricableEstimationData.length === 0)
  ) {
    return "";
  }

  let html = '<table border="">';
  html += `<thead><tr><th>Category</th><th>Subcategory</th><th>Item Name</th><th>Item Description</th><th>Line Price</th><th>Unit Cost</th><th>Quantity</th><th>Total Item Cost</th></tr></thead><tbody>`;

  estimationData?.forEach((service) => {
    service.selectedSubServices?.forEach((subService) => {
      const serviceCategory = subService.label;
      let linePriceText = `$${formatPrice(subService.unitPrice)}${subService.linePriceUnitLabel}`;
      let unitPriceText = `$${formatPrice(subService.unitPrice)}`;
      const price = subService.price;
      let priceText = `$${formatPrice(price)}`;
      let captionNoteText = subService.captionNote || "";
      if (subService.id === "driveway-size") {
        captionNoteText = `Based on $${formatPrice(subService.unitPrice)}${subService.linePriceUnitLabel}`;
      }

      if (price === DASH_FOR_PRICE_QUOTE_FIELDS) {
        linePriceText = price;
        unitPriceText = price;
        priceText = price;
      }
      html += `<tr><td>${service.name}</td><td>${serviceCategory}</td><td>${subService.itemName}</td><td>${captionNoteText}</td><td>${linePriceText}</td><td>${unitPriceText}</td><td>${subService.quantities}</td><td>${priceText}</td></tr>`;
    });
  });

  nonPricableEstimationData?.forEach((service) => {
    if (service.id === HOLIDAY_LIGHTING_ID) {
      html += `<tr><td>${service.name}</td><td>${service.serviceDetails}</td><td>${service.itemName}</td><td>${service.captionNote}</td><td>--</td><td>--</td><td>--</td><td>--</td></tr>`;
    } else if (service.id === WINDOW_TINTING_ID) {
      service.selectedSubServices?.forEach((subService) => {
        const serviceCategory = subService.label;
        html += `<tr><td>${service.name}</td><td>${serviceCategory}</td><td>${subService.label}</td><td>${service.captionNote}</td><td>--</td><td>--</td><td>--</td><td>--</td></tr>`;
      });
    }
  });

  //Added quoteMinimum(api result) and calculated service minimum from formValues
  let quoteMinimum = formValues?.quoteMinimum;
  const serviceMinimum = formValues?.serviceMinimum;
  let serviceMinimumQty = Number(serviceMinimum) > 0 ? 1 : 0;
  if (serviceMinimum === DASH_FOR_PRICE_QUOTE_FIELDS) {
    quoteMinimum = serviceMinimum;
    serviceMinimumQty = serviceMinimum;
  }

  html += `<tr><td></td><td></td><td>Service Minimum</td><td>Service Minimum</td><td>$${formatPrice(serviceMinimum)}</td><td>$${formatPrice(quoteMinimum)}</td><td>${serviceMinimumQty}</td><td>$${formatPrice(serviceMinimum)}</td></tr>`;

  html += "</tbody></table><br/>";

  const totalPriceEstimation = formValues?.totalPriceEstimation;
  let estimateTotalText = "";
  if (
    totalPriceEstimation &&
    totalPriceEstimation !== DASH_FOR_PRICE_QUOTE_FIELDS
  ) {
    estimateTotalText = totalPriceEstimation;
  } else {
    estimateTotalText = `$--`;
  }

  html += `<table border=""><thead><tr><th>Total</th></tr></thead><tbody><tr><td>${estimateTotalText}</td></tr></tbody></table>`;

  return html;
}
